import styled from 'styled-components';

import { ContentBanner as ContentBannerComponent } from '@xingternal/banner';
import { Button as ButtonComponent } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceXXL } from '@xingternal/tokens';
import { BodyCopy as BodyCopyComponent } from '@xingternal/typography';

export const ContentBanner = styled(ContentBannerComponent)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  overflow-wrap: break-word;
  hyphens: auto;
  padding: 20px;
  gap: ${spaceXXL};
`;

export const BodyCopy = styled(BodyCopyComponent)`
  @media ${mediaConfined} {
    margin: auto;
  }
`;

export const Button = styled(ButtonComponent)`
  flex-shrink: 0;
`;
